<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable"  @btnclick="bthClick" :pageData="pageData"></table-page>
    <UPDATE  ref="childUpdate"  @submit="submit" :updateData="updateData"></UPDATE>
  </div>
</template>

<script>
  //table封装组件
  import tablePage from '@/components/page/table.vue'
  import FORM from '@/components/page/form.vue'
  import UPDATE from '@/components/page/update.vue'
  import URL from '@/views/newmis36/util/url'
  import DateUtil from '@/utils/IM/tradeDataUtil.js'
  import Qs from 'qs'
  let paymentType = {"VIRTUAL_CURRENCY":"电子钱包","REAL_CURRENCY":"银行卡"}
  let day = {1:"星期一",2:"星期二",3:"星期三",4:"星期四",5:"星期五",6:"星期六",0:"星期日"}
  let status = {1:"禁用",2:"启用"}
  export default {
    name: 'cashoutlimit',
    components: {
      tablePage,
      FORM,
      UPDATE
    },
    methods: {
      /*表格按钮点击事件*/
      bthClick (clickName, row) {
        if (clickName == "update"){
          this.$refs.childUpdate.open(row);
        }else if (clickName == "copy"){
          row.id = null;
          this.$refs.childUpdate.open(row);
        }else if("delete" == clickName) {
          this.dataChanage(URL.cashoutlimit.delete, {id: row.id}, res => {
            if (res.code == 0) {
              this.$refs.childUpdate.close();
              this.$message.success("suc");
            } else {
              this.$message.error("suc");
            }
            this.$refs.childTable.defaultQueryData(this.queryData);
          });
        }
      },
      /*查询表单按钮点击事件*/
      formclick(clickName, data){
        if("查询" == clickName){
          this.queryData = data;
          this.$refs.childTable.defaultQueryData(this.queryData);
        }else if("新增" == clickName){
          this.$refs.childUpdate.open();
        }
      },
      /*新增或跟提交数据触发事件*/
      submit(model){
        //根据是否包含id更新还是添加
        this.dataChanage(URL.cashoutlimit.edit,model,res => {
          if (res.code == 0){
            this.$refs.childUpdate.close();
            this.$message.success("suc");
          }else{
            this.$message.error("suc");
          }
          this.$refs.childTable.defaultQueryData(this.queryData);
      })
      },
      dataChanage(url,option,suc,fail){
          this.axios.post(url, Qs.stringify(option || {})).then(res => {
          if(suc && (typeof suc == 'function')) suc(res);
        }).catch(res => {
            if(fail && (typeof fail == 'function')) fail(res);
        })
      }
    },
    data () {
      return {
        deleteIds:"",
        queryData:{},
        /*新增或更新*/
        updateData:{
          cols:[
            { title: 'id', field: 'id',hidden:true},
            { title: '提款方式', field: 'paymentType',type:2,optionList:paymentType,required:true},
            { title: '限制日期', field: 'day',type:2,optionList:day,isNumber:true,required:true},
            { title: '开始时间', field: 'startTime',type:16},
            { title: '结束时间', field: 'endTime',type:16},
            { title: '上限金额', field: 'upperLimit',type:7},
            { title: '状态', field: 'status',type:2,optionList:status,isNumber:true,required:true},
          ]
        },
        /*from查询表单*/
        formData:{
          hasLable: true,
          cols:[
            { title: '提款方式', field: 'paymentType',type:2,optionList:paymentType},
            { title: '状态', field: 'status',type:2,optionList:status,isNumber:true},
            {click:"查询"},
            {click:"新增"},
          ]
        },
        /*table生成*/
        pageData: {
          queryUrl: URL.cashoutlimit.list, //请求路径和参数
          /*selection: true,*/
          sequence: true,
          cols: [
            { title: '提款方式', field: 'paymentType',render:(data,full)=>{
                return paymentType[data];
              }},
            { title: '限制日期（周-至周日）', field: 'day',render:(data,full)=>{
                return day[data];
              }},
            { title: '开始时间', field: 'startTime'},
            { title: '结束时间', field: 'endTime'},
            { title: '上限金额', field: 'upperLimit'},
            { title: '状态', field: 'status',render:(data,full)=>{
                return status[data];
              }},
            { title: '创建时间', field: 'createTime',render:(data)=>{
                return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
              }},
            { title: '更新时间', field: 'updateTime',render:(data)=>{
                return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
              }},
            { title: '创建人', field: 'creator'},
            { title: '更新人', field: 'updater'},
            {title:"操作", btnClick: [
              { name: "复制", size: 'mini', click: 'copy', type: 'primary' ,icon:"el-icon-update"},
              { name: "修改", size: 'mini', click: 'update', type: 'primary' ,icon:"el-icon-update"},
              { name: "删除", size: 'mini', click: 'delete', type: 'primary' ,icon:"el-icon-delete"},
              ]
            }
        ]}
      }
    }
  }
</script>
